const MetadataColors = {
    colors: {
        color1: '#4a285a', // Deep Purple
        color2: '#6d377a', // Purple
        color3: '#8e527e', // Light Purple
        color4: '#a36d82', // Pinkish Purple
        color5: '#c79ab3', // Pale Purple
        color6: '#e1c7e0', // Very Pale Purple
    },
}

export default MetadataColors;
